import { EventosService } from './../../../core/services/eventos.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeriaService } from 'src/app/core/services/feria.service';
import { MarketplaceService } from 'src/app/core/services/marketplace.service';
import { YincanaService } from 'src/app/core/services/yincana.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';

/* ********************************************************** */
import { EventoFeriaEscolarComponent } from './../evento-feria-escolar/evento-feria-escolar.component';
import { EventoFeriaPersonalizadaComponent } from '../evento-feria-personalizada/evento-feria-personalizada.component';
import { EventoConferenciaComponent } from './../evento-conferencia/evento-conferencia.component';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { EventoComponent } from '../evento/evento.component';
import { EventoFeriaComponent } from '../evento-feria/evento-feria.component';
import { EventoYincanaComponent } from '../evento-yincana/evento-yincana.component';
/* ********************************************************** */

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public usuario = null;
  public marketplaces = null;
  public data_for_url = {};
  public ferias = null;
  public yincanas = null;

  public empresa = null;

  constructor(
    private svUsuario: UsuarioService,
    private router: Router,
    private svUtils: UtilsService,
    private svMarketplaces: MarketplaceService,
    private svFerias: FeriaService,
    private svYincanas: YincanaService,
    private svEvents: EventosService,

    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getLoggedUser();
    localStorage.removeItem('ed');
  }

  desableEvents() {
    this.svEvents.disableEvents().subscribe((resp) => {
      console.log(resp);
    });
  }

  getUserInfo(id) {
    this.svUsuario.getUser(id).subscribe((resp) => {
      // console.log(resp)
      if (resp['status'] === 'success') {
        localStorage.setItem(
          'ud',
          btoa(JSON.stringify(resp['body']['data'][0]))
        );

        this.usuario = this.svUtils.getLoggedUser();
        this.desableEvents();
        if (this.usuario.id_empresa_perteneciente) {
          this.getCompany(this.usuario.id_empresa_perteneciente);
          this.getMarketplaces(this.usuario.id_usuario);
          this.getFerias(this.usuario.id_usuario);
          this.getYincanas(this.usuario.id_usuario);
        }
      }
    });
  }

  goToStats(event) {
    localStorage.setItem('ev_d', window.btoa(JSON.stringify(event)));
    this.router.navigate(['auth/stats']);
  }

  goToMisEventos() {
    this.router.navigate(['auth/events']);
  }
  goToNoticias() {
    this.router.navigate(['auth/news']);
  }
  goToPlanes() {
    this.router.navigate(['auth/plans']);
  }
  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
    this.getUserInfo(this.usuario.id_usuario);
  }

  getCompany(id_empresa_usuario) {
    this.svUsuario.getCompany(id_empresa_usuario).subscribe((resp) => {
      if (resp['status'] === 'success') {
        resp = resp['body']['data'][0];
        localStorage.setItem('empresa', JSON.stringify(resp));
        this.empresa = resp;
      }
    });
  }

  getMarketplaces(id_usuario) {
    this.svMarketplaces.getMarketplaces(id_usuario).subscribe((_market) => {
      if (_market) {
        if (_market['body']['status'] == 'success') {
          this.marketplaces = _market['body']['data'];
        }
      }
    });
  }
  getFerias(id_usuario) {
    this.svFerias.getFerias(id_usuario).subscribe((_feria) => {
      if (_feria) {
        if (_feria['body']) {
          if (_feria['body']['status'] == 'success') {
            this.ferias = _feria['body']['data'];
          }
        }
      }
    });
  }
  getYincanas(id_usuario) {
    this.svYincanas.getYincanas(id_usuario).subscribe((_yincana) => {
      if (_yincana) {
        if (_yincana['body']) {
          if (_yincana['body']['status'] == 'success') {
            this.yincanas = _yincana['body']['data'];
          }
        }
      }
    });
  }
  editEvent(id_evento, tipo_evento) {
    let id_tipo_evento = id_evento;
    let nombre_id_tipo = 'id_marketplace';

    if (tipo_evento == 'feria') {
      nombre_id_tipo = 'id_feria';
    }else if(tipo_evento == 'yinkana'){
      nombre_id_tipo = 'id_yinkana';
    }

    let empresa = JSON.parse(localStorage.getItem('empresa'));

    if(tipo_evento == 'yinkana'){
      this.data_for_url = {
        token: this.svUtils.getAt(),
      };
    }else{
      this.data_for_url = {
        id_empresa_usuario: empresa.id_empresa_usuario,
        token: this.svUtils.getAt(),
      };
    }

    this.data_for_url[nombre_id_tipo] = id_tipo_evento;
    this.data_for_url = btoa(JSON.stringify(this.data_for_url));

    let furl = empresa.subdominio_empresa_usuario.slice(0, 8);
    let url = '';

    if (furl == 'https://') {
      url = empresa.subdominio_empresa_usuario;
    } else {
      url = 'https://' + empresa.subdominio_empresa_usuario;
    }

    if (tipo_evento == 'feria') {
      window.open(`${url}/admin-feria/?ed=${this.data_for_url}`, '_blank');
    }else if(tipo_evento == 'yinkana'){


      window.open(`${"https://andrup23.github.io/admin-ar-event-page/?"}ed=${this.data_for_url}`, '_blank');


    } else {
      window.open(`${url}/admin/?ed=${this.data_for_url}`, '_blank');
    }
  }

  visitEvent(id_evento, tipo_evento, tipo_feria?) {
    let nombre_id_tipo = 'id_marketplace';
    /********* * CAMBIAR POR SWITCH CASE ***********/
    if (tipo_evento == 'feria') {
      nombre_id_tipo = 'id_feria';
    }else if(tipo_evento == 'yinkana'){
      nombre_id_tipo = 'id_yinkana';
    }

    let empresa = JSON.parse(localStorage.getItem('empresa'));

    if(tipo_evento == 'yinkana'){
      this.data_for_url = {
        token: this.svUtils.getAt(),
      };
    }else{
      this.data_for_url = {
        id_empresa_usuario: empresa.id_empresa_usuario,
        token: this.svUtils.getAt(),
      };
    }
    

    /* ****** */

    if (tipo_evento == 'feria') {
      this.data_for_url['tipo_feria'] = tipo_feria;
    }
    this.data_for_url[nombre_id_tipo] = id_evento;
    this.data_for_url = btoa(JSON.stringify(this.data_for_url));

    let url = '';
    url = `https://eventvr.infoverses.com/marketplace/personalizacion/?`;
    if (tipo_evento == 'feria') {
      url = `https://expoeventvr.infoverses.com/feria/personalizacion/?`;
    }else if(tipo_evento == 'yinkana'){
      url = `https://andrup23.github.io/ar-test/?`;
    }

    window.open(`${url}ed=${this.data_for_url}`, '_blank');
  }

  truncateText(texto) {
    return texto.substr(0, 30) + '...';
  }

  openMarketplaceEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      // Swal.fire(
      //   'Cuenta inactiva',
      //   'Debes comprar un plan comercial para crear eventos',
      //   'warning'
      // ).then((result) => {
      //   if (result.isConfirmed) {
      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      //   }
      // });
      return;
    }
    const dialogRef = this.dialog.open(EventoComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }

  openFeriaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      // Swal.fire(
      //   'Cuenta inactiva',
      //   'Debes comprar un plan comercial para crear eventos',
      //   'warning'
      // ).then((result) => {
      //   if (result.isConfirmed) {
      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      //   }
      // });
      return;
    }
    const dialogRef = this.dialog.open(EventoFeriaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
  openConferenciaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      // Swal.fire(
      //   'Cuenta inactiva',
      //   'Debes comprar un plan comercial para crear eventos',
      //   'warning'
      // ).then((result) => {
      // if (result.isConfirmed) {
      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      // }
      // });
      return;
    }
    /* const dialogRef = this.dialog.open(EventoConferenciaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    }); */
  }
  openFeriaEscolarEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      // Swal.fire(
      //   'Cuenta inactiva',
      //   'Debes comprar un plan comercial para crear eventos',
      //   'warning'
      // ).then((result) => {
      //   if (result.isConfirmed) {
      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      //   }
      // });
      return;
    }
    const dialogRef = this.dialog.open(EventoFeriaEscolarComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }

  openFeriaPersonalizadaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      // Swal.fire(
      //   'Cuenta inactiva',
      //   'Debes comprar un plan comercial para crear eventos',
      //   'warning'
      // ).then((result) => {
      //   if (result.isConfirmed) {
      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      //   }
      // });
      return;
    }
    const dialogRef = this.dialog.open(EventoFeriaPersonalizadaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }

  openYincanaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {

      Swal.fire({
        title: '¿Qué desea hacer?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonColor: '#7066e0',
        denyButtonColor: '#7066e0',
        confirmButtonText: 'Crear demo',
        denyButtonText: 'Comprar plan',
        showCloseButton: true,
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = 'auth/start-demo';
        } else if (result.isDenied) {
          window.location.href = 'auth/plans';
        }
      });
      return;
    }
    const dialogRef = this.dialog.open(EventoYincanaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
}
